<template>
    <CheckboxGroup
        class="cursor-pointer"
        :value="value"
        :options="priorities"
        :disabled="disabled"
        @input="$emit('input', $event)"
    />
</template>

<script>
  import { ISSUE_PRIORITY } from '@/_legacy/constants';
  import CheckboxGroup from '@/_legacy/components/CheckboxGroup.vue';

  export default {
    name: 'PrioritySelector',
    components: {
      CheckboxGroup,
    },
    props: {
      value: {
        type: Number,
        default: 0,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      priorities() {
        return [
          {
            key: ISSUE_PRIORITY.MEDIUM,
            value: this.$t('Normal'),
            status: 'bg-60',
          },
          {
            key: ISSUE_PRIORITY.HIGH,
            value: this.$t('High'),
            status: 'bg-red',
          },
        ];
      },
    },
  };
</script>
